export const DAILY_FIELDS = {
    id: 'id',
    date: 'التاريخ',
    storeName: 'المتجر',
    branchName: 'الفرع',
    appKey: 'معرف المتجر',
    appBranchId: 'معرف الفرع',
    app: 'التطبيق',
    completed: "الطلبات المكتملة",
    completedAmount: "قيمة الطلبات",
    rejected: "المرفوضة",
    canceled: "الملغاة",
    canceledAmount: "قيمة الملغاة",
    endurance: 'التحمل',
    refund: 'الاسترداد',
}
export const DAILY_FIELDS2 = {
    id: 'id',
    date: 'date',
    storeName: 'storeName',
    branchName: 'branchName',
    storeId: 'storeId',

    appKey: 'appKey',
    branchRef: 'branchRef',

    appBranchId: 'appBranchId',
    app: 'app',
    completed: "completed",
    completedAmount: "completedAmount",
    rejected: "rejected",
    rejectedAmount: "rejectedAmount",
    canceled: "canceled",
    canceledAmount: "canceledAmount",
    endurance: 'endurance',
    refund: 'refund',
    enduranceAmount: 'enduranceAmount',
    refundAmount: 'refundAmount',
}

